





















































































































import { Component, Mixins } from "vue-property-decorator";
import { IStatRange } from "@/models/stats";
import QueryMixin from "@/mixins/queryMixin";
import { QUERY_PARAMS, STATS_DEFAULT_CURRENCY_CODE } from "@/data/constants";
import CurrenciesStore from "@/mixins//constants/currenciesStore";
import { DataModules } from "@/store/modules/data";
import { ImportStatusCodes } from "@/data/enums/imports";
import { mapState } from "vuex";
import { IImport } from "@/models/imports";
import ChartProvider from "@/components/app/global/stats/charts/chart/chartProvider.vue";
import MRRTable from "@/components/app/global/stats/mrrTable.vue";

@Component({
  components: {
    "mrr-controls": () =>
      import("@/components/app/global/stats/mrrControls.vue"),
    "mrr-chart": () =>
      import("@/components/app/global/stats/charts/mrrChart.vue"),
    "mrr-counts-chart": () =>
      import("@/components/app/global/stats/charts/mrrCountsChart .vue"),
    "mrr-stat": () => import("@/components/app/global/stats/mrrStat.vue"),
    "mrr-client-average-stat": () =>
      import("@/components/app/global/stats/mrrClientAverageStat.vue"),
    "mrr-service-average-stat": () =>
      import("@/components/app/global/stats/mrrServiceAverageStat.vue"),
    "mrr-client-count-stat": () =>
      import("@/components/app/global/stats/mrrClientClountStat.vue"),
    "mrr-service-count-stat": () =>
      import("@/components/app/global/stats/mrrServiceCountStat.vue"),
    "mrr-table": MRRTable,
    ChartProvider
  },
  computed: {
    ...mapState({
      imports(state, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.IMPORTS,
          scope: this.importsScope
        });
      }
    })
  }
})
export default class MonthlyRunRate extends Mixins(
  QueryMixin,
  CurrenciesStore
) {
  public $refs!: {
    chartProviderMRR: ChartProvider;
    chartProviderMRRCount: ChartProvider;
    mrrTable: MRRTable;
  };

  public currencyCode = STATS_DEFAULT_CURRENCY_CODE;
  public importId: IImport["id"] | null = null;
  public imports!: IImport[];
  public importsScope = `$${ImportStatusCodes.COMPLETE}_list`;
  public isLoading = true;
  public stat: IStatRange = { dateFrom: new Date() };

  public async created() {
    try {
      await Promise.all([
        this.$store.dispatch("constants/getCurrencies"),
        this.getCompletedImports()
      ]);

      const dateParam = this.qetQueryParam(QUERY_PARAMS.DATE);
      const currencyParam = this.qetQueryParam(QUERY_PARAMS.CURRENCY);

      if (dateParam)
        this.stat.dateFrom = this.parseQueryParamToDate(dateParam as string);
      if (currencyParam && this.currencies.find(i => i.code === currencyParam))
        this.currencyCode = currencyParam as string;

      // Important to add the watchers after data from query is set if any
      this.$watch("currencyCode", value => {
        if (value === STATS_DEFAULT_CURRENCY_CODE)
          this.removeQueryParam(QUERY_PARAMS.CURRENCY);
        else this.addQueryParam({ key: QUERY_PARAMS.CURRENCY, value });
      });

      this.$watch("stat.date", value => {
        if (this.$moment(this.stat.dateFrom).isSame(new Date(), "day"))
          this.removeQueryParam(QUERY_PARAMS.DATE);
        else
          this.addQueryParam({
            key: QUERY_PARAMS.DATE,
            value: this.parseDateToQueryParam(value)
          });
      });

      this.$watch(
        "$route.query",
        query => {
          if (!query[QUERY_PARAMS.CURRENCY])
            this.currencyCode = STATS_DEFAULT_CURRENCY_CODE;

          if (!query[QUERY_PARAMS.DATE]) this.stat.dateFrom = new Date();
        },
        { deep: true }
      );
    } finally {
      this.isLoading = false;
    }
  }

  public beforeDestroy() {
    this.$store.dispatch("data/bin", {
      storeModule: DataModules.IMPORTS,
      scope: this.importsScope,
      vm: this
    });
  }

  public getCompletedImports() {
    return this.$store.dispatch(`data/${DataModules.IMPORTS}/list`, {
      vm: this,
      scope: this.importsScope,
      params: {
        order: "id",
        with: "status",
        limit: 0,
        "filter[status.code]": ImportStatusCodes.COMPLETE
      }
    });
  }

  public getDateFromIndex() {
    return this.$refs.mrrTable.table.findIndex(i =>
      this.$moment(i.date).isSame(this.stat.dateFrom, "day")
    );
  }

  public onHover(hover) {
    if ([0, 1, 2, null].includes(hover.column)) {
      this.$refs.chartProviderMRR.setHover({
        hoverIndex: hover.index,
        hoverDatasetIndex: hover.column
      });
    }
    // Check if its 3rd ot 4th column which are for the second chart
    // Null is to allow clearing the tooltip
    if ([3, 4, null].includes(hover.column)) {
      this.$refs.chartProviderMRRCount.setHover({
        hoverIndex: hover.index,
        // We remove 3 because there are 3 columns before
        hoverDatasetIndex: hover.column - 3
      });
    }
  }
}
